import { Modal, Button } from "react-bootstrap";
import { upperCaseConverter } from "../utils/helpers";


import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import {  DialogActions, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Checkbox, FormControlLabel } from "@mui/material";
import classes from "./dialog.module.css";
import { useState } from "react";


let requiredCount = {
  sentiment: 5,
  "propensity-to-buy": 5,
};

function ConfirmTempplateModal({
  show,
  handleClose,
  handleConfirmDeletion,
  selectedId,
  message,
  attributeLength,
  selectedTab,
  

}) {


  let key = `${selectedTab === 'sentiment' ? `sentiment questions` : selectedTab === 'propensity-to-buy' ? `purchase intent questions` : selectedTab}`;
  return (
    <Modal show={show} onHide={handleClose}
      style={{ zIndex: 2000 }} // custom z-index

    >
        {
            requiredCount[selectedTab]>=attributeLength?
            <>
             <Modal.Header closeButton >
        <Modal.Title>{`Minimum ${upperCaseConverter(key)} limit`}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{`At least ${requiredCount[selectedTab]} ${key} must be included. Further deletion of ${key} is not permitted.`}</Modal.Body>
            </>
            :
            
     <>
      <Modal.Header closeButton>
        <Modal.Title>{`Confirm ${upperCaseConverter(key)} Deletion`}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{`Are you sure you want to delete  this ${key}?`}</Modal.Body>
      <Modal.Footer
        style={{ padding: "5px 12px", color: "white", fontSize: "14px" }}
      >
        <Button
          style={{ backgroundColor: "#30c6b7",width:'60px',height:'40px' }}
          variant="success"
          onClick={() => handleConfirmDeletion(selectedId)}
        >
          Ok
        </Button>
        <Button
          style={{ backgroundColor: "#ff7a00",width:'80px',height:'40px' }}
          variant="danger"
          onClick={handleClose}
        >
          Cancel
        </Button>
      </Modal.Footer>
      </>
    

}
    </Modal>
  );
}

export function MessageModal({
  show,
  handleClose,
  message,
  title,
}) {
 
  return (
    <Modal show={show} onHide={handleClose} 
      style={{ zIndex: 2000 }} // custom z-index

    >
      <Modal.Header closeButton>
        <Modal.Title>
          {title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {message}</Modal.Body>
    </Modal>
  );
}


export const MessageModal1 = ({
  show,
  handleClose=()=>{},
  title,
  width,
  height = "100%",
  showLaunchDialog = false,
  message
}) => {


  return (
    <Dialog
      open={show}
      onClose={() => {
        handleClose();
      }}
      sx={{
        height: height,
      }}
      PaperProps={{
        sx: {
         width: "100%",
          maxWidth: `${width}px!important`,
        },
      }}
    >
      <div className={classes.header}>
        <DialogTitle className={classes.title}>{title}</DialogTitle>
        {!showLaunchDialog &&
          <IconButton id="close_id" onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        }
      </div>
      <DialogContent className={classes.content}>{message}</DialogContent>
     
    </Dialog>
  );
};



export default ConfirmTempplateModal;
